import React from 'react'
import Error404 from '../Error404'

function Error() {
  return (
    <>
    <Error404/>
    </>
  )
}

export default Error